// Module
var code = "<script id=\"wcc-components-wcc-content-cards-score-answer\" type=\"text/template\">\r\n    <cards-score-answers params=\"topicId: topicId, answers: answers\"></cards-score-answers>\r\n</script>";
// Exports
module.exports = code;